module.exports = __webpack_public_path__ + "static/media/cox-dt-color-logo.23586294.png";